import React from "react";

export default function Bookmark({color}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
    >
      <g clip-path="url(#clip0_2068_504)">
        <path
          d="M5.0625 1.6875L21.9375 1.6875L21.9375 27L13.5 19.3219L5.0625 27L5.0625 1.6875Z"
          fill={color || "#FFCB00"}
        />
      </g>
      <defs>
        <clipPath id="clip0_2068_504">
          <rect width="27" height="27" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
